import {h, cloneElement, toChildArray} from 'preact';
import './index.less';
import {useEffect, useRef, useState} from "preact/hooks";
import cx from "classnames";

const Layout = ({children, title, extra}) => {
  const childrenRef = useRef();
  const contentRef = useRef();
  const [isBorder, setBorder] = useState(false)
  useEffect(() => {
    const element = childrenRef.current.getBoundingClientRect ? childrenRef.current : childrenRef.current.base;
    let num = 0;
    let originTop = 0;
    const scroll = () => {
      if(childrenRef.current){
        if(!num){
          num++;
          originTop = element.getBoundingClientRect().top;
        }
        setBorder(true);
        if(originTop <= element.getBoundingClientRect().top) {
          setBorder(false);
        }
      }
    }
    contentRef.current.addEventListener('scroll', scroll);
    return () => {
      contentRef.current.removeEventListener('scroll', scroll);
    }
  }, [childrenRef.current]);
  return <div className={'xfe_common_layout_root'}>

    <div className={cx('xfe_common_layout_title_wrap', isBorder && 'border')}>
      <div className={cx('xfe_common_layout_title')}>
        {title}
      </div>
    </div>
    <div ref={contentRef} className={'xfe_common_layout_content'}>
      {toChildArray(children).map((child) => {
        if (typeof child === 'object') {
          return cloneElement(child, {
            ref: childrenRef
          })
        }
        return child;
      })}
    </div>
    {extra}
  </div>
}

export default Layout;
